import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-23d7f51a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "duration-content" }
const _hoisted_2 = { class: "pvd-modal__heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/prgw/digital/finewissues/client/assets/clock.svg",
  alt: "Clock with the upper left corner not shaded in"
}, null, -1))
const _hoisted_4 = {
  id: "durationContentHeader",
  slot: "heading"
}
const _hoisted_5 = { id: "durationContentSubHeader" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "grayBar",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = { id: "slider-component" }
const _hoisted_8 = { id: "time-period-slider-component" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "screen-reader-only" }, "(Goes back a page in the modal)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd_field_group = _resolveComponent("pvd-field-group")!
  const _component_fractional_cd_slider = _resolveComponent("fractional-cd-slider")!
  const _component_pvd_button = _resolveComponent("pvd-button")!
  const _component_pvd_progress_indicator = _resolveComponent("pvd-progress-indicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_pvd_field_group, { id: "topHeading" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.clientConstants.DURATION_CONTENT_HEADER), 1)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.clientConstants.DURATION_CONTENT_SUB_HEADER), 1)
      ]),
      _: 1
    }),
    _hoisted_6,
    _createVNode(_component_pvd_field_group, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_fractional_cd_slider, {
              id: `time-period-slider`,
              values: _ctx.clientConstants.timePeriodList,
              currentValue: _ctx.sliderIndex,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.durationChanged($event)))
            }, null, 8, ["values", "currentValue"])
          ])
        ]),
        _createVNode(_component_pvd_button, {
          id: "durationContentOptionsButton",
          "pvd-type": "submit",
          "pvd-full-width": "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewButtonClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.clientConstants.DURATION_CONTENT_OPTIONS_BUTTON), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_pvd_button, {
          id: "durationContentBackButton",
          "pvd-type": "submit",
          "pvd-full-width": "",
          "pvd-variant": "secondary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.backButtonClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.clientConstants.BACK_BUTTON) + " ", 1),
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_pvd_progress_indicator, {
      "pvd-active-step-index": "1",
      "pvd-steps": "[\"\",\"\", \"\"]"
    })
  ]))
}